module.exports = __webpack_public_path__ + "img/hys-6.3d6943c7.jpg";